import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const UPDATE_ACCOUNT_DETAILS = gql`
  mutation UpdateAccountDetails($input: UpdateAccountDetailsInput!) {
    updateAccountDetails(input: $input) {
      id
      # Business Details
      business_dba
      legal_name
      primary_contact
      title
      phone
      country_code
      calling_code
      # Promoter Information
      promoter_name
      promoter_email
      promoter_phone
      website
      org_name
      promoter_type
      # Addresses
      track {
        name
        address_line_1
        address_line_2
        city
        state
        zipcode
      }
      mailing {
        name
        address_line_1
        address_line_2
        city
        state
        zipcode
      }
      shipping {
        name
        address_line_1
        address_line_2
        city
        state
        zipcode
      }
      # Logos
      logo_id
      kiosk_logo_id
      # POS Settings
      pos
      pos_settings {
        payment
        calculator
        ticket_delivery
        receipt_delivery
      }
      pos_fee_dollar
      pos_fee_percent
      # Device Settings
      janam_scanners
      janam_scanner_count
      kiosk_scanners
      kiosk_scanner_count
      pos_printers
      pos_printer_count
      scan_out
      # Reserved Seat Settings
      orphaned_seats
      best_available
      # Payment Settings
      stripe_account_id
      # Waivers & Agreements
      insurance_company
      waivers {
        id
        name
      }
      agreements {
        id
        name
      }
    }
  }
`;

export function useUpdateAccountDetails() {
  const [updateAccountDetailsMutation, { loading }] = useMutation(
    UPDATE_ACCOUNT_DETAILS
  );

  const updateAccountDetails = useCallback(
    async (input) => {
      try {
        const result = await updateAccountDetailsMutation({
          variables: { input },
        });
        return { success: true, data: result.data?.updateAccountDetails };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    [updateAccountDetailsMutation]
  );

  return { updateAccountDetails, loading };
}
